import React from "react";
import styles from './quoatation.module.scss';
import { Alert } from 'antd'


const CancelRequest = () => {
    return <div className={styles.container}>
        <h3>Task For You</h3>
        <Alert message="Order cancelled" description='Order has been cancelled , it will be auto deleted in 5 days' />

    </div>
}
export default CancelRequest